import { ButtonContainer } from 'src/components/Button/style/Button.style';
import Icon from 'src/components/Icon/Icon.component';
import NeedHelpButton from 'src/components/NeedHelpButton/NeedHelpButton.component';
import Translate from 'src/components/Translate/Translate.component';
import { ReactComponent as expired_link } from 'src/images/pageStatus/expired_link.svg';
import React from 'react';
import { H4 } from 'src/style-utils/typographic';
import { ErrorPagePar } from '../style/failedPage.style';
import { StyleSheetManager } from 'styled-components';
import { shouldForwardProp } from 'src/style-utils/functions';

const ExpiredLink: React.FC = () => {
  return (
    <StyleSheetManager shouldForwardProp={shouldForwardProp}>
      <Icon
        svgIconComponent={expired_link}
        iconHeight="auto"
        iconSize="min(100%, 25.6rem)"
        margin="4.2rem auto"
      />
      <H4 textAlign="center">
        <Translate id="lbl.expiredLink" />
      </H4>
      <ErrorPagePar>
        <Translate id="text.expiredLink" />
      </ErrorPagePar>
      <ButtonContainer>
        <NeedHelpButton />
      </ButtonContainer>
    </StyleSheetManager>
  );
};

export default ExpiredLink;
